export default {
  name: 'More',
  props: {
    title: {
      type: String,
      default: '更多'
    },
    data: {
      type: Array,
      default: function() {
        return []
      }
    }
  },

  methods: {
    handleClick(name) {
      this.$emit('click', name)
    }
  },

  render(){
    const slots = {
      default:()=>{
        return this.$scopedSlots.default ? this.$scopedSlots.default() : <a href="javascript:void(0)">{this.title}<Icon type="ios-arrow-down"></Icon></a>
      },
      list:()=>{
        return <DropdownMenu>
          {
            this.data.map(item => <DropdownItem name={item.value}>{item.label}</DropdownItem>)
            
          }
        </DropdownMenu>
      }
    }
    return <Dropdown scopedSlots={slots} trigger="click" on-on-click={this.handleClick} transfer={true}></Dropdown>
  }
}
